const useStrippedString = (value: string): string => value?.replace(/<p[^>]*>/g, '')?.replace(/<\/p>/g, '<br>') || '';

export {
  useStrippedString,
}
